<template>
  <div class="flex items-center gap-1">
    <ui-keyboard-key v-for="key in combo" :key="key" :keyboard-key="key" :theme="theme" :size="size" />
    <template v-if="alternative">
      <span class="font-medium text-gray-50" :class="{ 'mx-1': size === 'large' }">/</span>
      <ui-keyboard-key v-for="key in alternative" :key="key" :keyboard-key="key" :theme="theme" :size="size" />
    </template>
  </div>
</template>

<script setup lang="ts">
import UiKeyboardKey, { type KeySize, type KeyTheme } from './UiKeyboardKey.vue'

withDefaults(
  defineProps<{
    combo: string[]
    alternative?: string[]
    size?: KeySize
    theme?: KeyTheme
  }>(),
  {
    alternative: undefined,
    size: 'large',
    theme: undefined,
  },
)
</script>
